import { MaskOptions } from "maska";
export const PHONE_NUMBER_MASK = "##########";
export const QUOTE_REF_MASK: MaskOptions = {
    mask: "A",
    tokens: {
        A: { pattern: /[a-zA-Z0-9]/, transform: (chr: string) => chr.toUpperCase(), repeated: true }
    }
};

export const DECIMAL_MASK: MaskOptions = {
    mask: "#NNNNN.DD",
    tokens: {
        N: {
            pattern: /[0-9]/,
            optional: true
        },
        D: {
            pattern: /[0-9]/,
            optional: true
        }
    }
};

export const MONEY_MASK = "['#','##','###', '#,###','##,###','###,###']";
export const COMMA_NUMBER_MASK = (length: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10) => {
    const possibleValues = [
        "'#'",
        "'##'",
        "'###'",
        "'#,###'",
        "'##,###'",
        "'###,###'",
        "'#,###,###'",
        "'##,###,###'",
        "'###,###,###'",
        "'#,###,###,###'"
    ];

    return `[${possibleValues.slice(0, length).join(",")}]`;
};
